var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup18(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 69,
    height: 69,
    transform: "translate(-5 -4)",
    fill: "#152d79"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(5.48 4.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(-0.48 -0.496)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M89.848,104.511a1.128,1.128,0,0,0-.523,1.505,26.286,26.286,0,0,1,2.639,11.543A26.578,26.578,0,0,1,49.41,138.816a3.381,3.381,0,1,0-1.614,1.6,28.831,28.831,0,0,0,46.421-22.859,28.525,28.525,0,0,0-2.863-12.525,1.127,1.127,0,0,0-1.505-.524",
    transform: "translate(-35.513 -87.466)",
    fill: "#152d79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M4.085,41.35a1.127,1.127,0,0,0,.557-1.493A26.313,26.313,0,0,1,2.254,28.847,26.623,26.623,0,0,1,28.847,2.254,26.26,26.26,0,0,1,44.4,7.292,3.382,3.382,0,1,0,46.23,5.84,28.833,28.833,0,0,0,0,28.847,28.56,28.56,0,0,0,2.592,40.794a1.126,1.126,0,0,0,1.493.556",
    transform: "translate(1.011 1.247)",
    fill: "#152d79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M70.91,49.5a21.41,21.41,0,1,0,21.41,21.41A21.381,21.381,0,0,0,70.91,49.5m-6.031,3.227c-2.328,2.768-3.737,6.719-4.467,10.295H53.454A19.257,19.257,0,0,1,64.878,52.727M51.754,70.91a19.076,19.076,0,0,1,.846-5.634h7.425a41.546,41.546,0,0,0,0,11.269H52.6a19.076,19.076,0,0,1-.846-5.634m1.7,7.888h6.958c.729,3.575,2.138,7.526,4.467,10.295A19.257,19.257,0,0,1,53.454,78.8M69.783,89.909c-3.1-.864-5.766-5.234-7.057-11.111h7.057Zm0-13.365H62.31a38.456,38.456,0,0,1,0-11.268h7.473Zm0-13.522H62.725c1.291-5.878,3.956-10.247,7.057-11.111ZM72.036,51.91c3.1.864,5.766,5.234,7.057,11.111H72.036Zm0,13.365h7.473a38.454,38.454,0,0,1,0,11.268H72.036Zm0,24.633V78.8h7.057c-1.291,5.878-3.956,10.247-7.057,11.111m4.9-.817c2.329-2.769,3.738-6.721,4.467-10.3h6.958a19.256,19.256,0,0,1-11.424,10.3M90.065,70.91a19.076,19.076,0,0,1-.846,5.634H81.794a41.54,41.54,0,0,0,0-11.268h7.425a19.076,19.076,0,0,1,.846,5.634m-8.658-7.888c-.729-3.575-2.138-7.526-4.467-10.295A19.258,19.258,0,0,1,88.365,63.022Z",
    transform: "translate(-41.052 -40.816)",
    fill: "#152d79"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup18);
export default __webpack_public_path__ + "static/media/Group18.c5a8ee7f2b4b31905c5b6137ad1f7b00.svg";
export { ForwardRef as ReactComponent };